import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
    paper: {
        marginTop: theme.spacing(8),
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
    },
    linkingInfo: {
        backgroundColor: '#4285F4',
        color: 'white',
        height: '50px',
        fontSize: '16px',
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    linkingError: {
        backgroundColor: 'red',
        color: 'white',
        height: '50px',
        fontSize: '16px',
        fontWeight: 600,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    linkingIcon: {
        height: '60px',
        width: '60px',
        color: '#4285F4',
        margin: 20
    },
    centeredText: {
        textAlign: 'center'
    }
}));

export { useStyles };